/** Same-origin path only — avoids `//evil.com` and `javascript:` open redirects. */
export function isAppInternalPath(path: string | undefined): path is string {
  return (
    typeof path === 'string' &&
    path.startsWith('/') &&
    !path.startsWith('//') &&
    !/^[a-z][a-z0-9+.-]*:/i.test(path)
  );
}

export const GetPropertyByPath = (path: string) => {
  if(path.includes('keyMetrics'))
    return 'keyMetric'
  if(path.includes('exams'))
    return 'exams'
  if(path.includes('accountability'))
    return 'accountability'
  if(path.includes('wellness'))
    return 'wellness'
  if(path.includes('actionItems'))
    return 'actionItems'
  return 'keyMetric'
}
